import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import PromotedStory from './promoted-story';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.stories != this.props.stories) {
            return true;
        }

        return false;
    }

    render({ stories, mode, img_size, limit }) {
        if (stories && stories.length) {
            const columnClass = this.props.mode && this.props.mode == 'sidebar' ? 'is-12' : 'is-6 is-12-mobile';
            return (
                <promoted-content mode={mode} img_size={img_size}>
                    {this.renderHeader()}
                    <row className='is-wrap'>
                        {stories.slice(0, limit).map((story, index) => (
                            <column className={columnClass}>
                                <PromotedStory
                                    story={story}
                                    index={index}
                                    mode={this.props.mode}
                                    img_size={this.props.img_size}
                                />
                            </column>
                        ))}
                    </row>
                </promoted-content>
            );
        }

        return (<promoted-content {...this.props} />);
    }

    renderHeader = () => {
        if (this.props.mode) {
            if (this.props.mode == 'sidebar') {
                return (
                    <h3>
                        {this.props.title || 'The Latest'}
                    </h3>
                );
            } else if (this.props.mode == 'product') {
                /* eslint-disable max-len */
                return (
                    <h2 className='is-h1 has-margin-10-left has-margin-0-bottom has-margin-0-left-mobile has-margin-10-bottom-mobile'>
                        {this.props.title || 'The Latest Articles'}
                    </h2>
                );
                /* eslint-enable max-len */
            } else if (this.props.mode == 'article') {
                return (
                    <h2 className='is-h1 has-margin-20-bottom has-margin-20-top has-margin-10-left'>
                        {this.props.title || 'The Latest Articles'}
                    </h2>
                );
            }
        }

        return (
            <header className='promoted_content_header'>
                <h2 className='is-h1 has-margin-20-bottom'>
                    {this.props.title || 'The Latest Articles'}
                </h2>
            </header>
        );
    }
}

const mapStateToProps = (state) => ({
    stories: state.content && state.content.featured_articles && state.content.featured_articles.data,
});

export default connect(mapStateToProps)(Component);
